











import {
  Vue,
  Component
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";

@Component({
  components: {
    GenericLoadingSpinner,
  },
})

export default class HsabInvestmentRedirectPage extends Vue {
  hsabInvestmentStore = useHsabInvestmentStore();

  created (): void {
    this.hsabInvestmentStore.loadInvestmentIframe();
  }

  onClick () {
    if (!this.hsabInvestmentStore.iframeLoaded) {
      return;
    }
    window.open(this.hsabInvestmentStore.iframeUrl, "_blank");
  }
}
